export default __webpack_public_path__ + "static/media/Micaella.56f48a0a.jpg";